export { default } from "./file-icon";
